import { render, staticRenderFns } from "./LatCustomData.vue?vue&type=template&id=9f605fde&"
import script from "./LatCustomData.vue?vue&type=script&lang=js&"
export * from "./LatCustomData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports